import React from 'react';
import './WhyOroro.css';

const WhyOroro = () => {
  const stats = [
    { number: '95%', label: 'Referral Business' },
    { number: '50+', label: 'Valued Clients' },
    { number: '200+', label: 'Products delivered' }
  ];

  return (
    <section className="why-cybage">
      <div className="Why-container">
        <div className="section-header">
          <h2>Why Ororo Software Solutions?</h2>
          <h3>A Legacy of Excellence Since 2015</h3>
          <p>
            With decade of experience in delivering excellence, Ororo is consistently moving forward—fusing exceptional talent, efficient processes, and emerging technologies to thrive in the ever-changing business terrain.
          </p>
        </div>

        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyOroro; 